import { TextInput } from '@frontend/components/basic-forms';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { UserSelectV2 } from '@frontend/user/select';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import { LuShoppingCart } from 'react-icons/lu';

import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import useEnterReceiverSupplier from './enter-receiver-supplier.controller';

const ID = 'enter-receiver-supplier';

const EnterReceiverSupplier = (props: { wizard_id: string }) => {
    const viewProps = useEnterReceiverSupplier(props);

    useWizardModalScreenNavigation({
        onContinue: viewProps.onSubmit,
        continueDisabled: viewProps.submitDisabled
    });

    return (
        <div
            id={ID}
            className='flex w-full flex-col gap-3'>
            <div className='flex items-start justify-start self-stretch'>
                <div className='text-foreground-default justify-start text-base font-medium'>{CommonMessage.FORMS.PROVIDE_THE_FOLLOWING}</div>
            </div>

            <div
                data-state='Open'
                className='outline-border-default inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4 outline-1'>
                <div className='inline-flex items-center justify-between self-stretch'>
                    <div className='flex items-center justify-start gap-4'>
                        <div className='outline-border-default relative flex size-12 items-center justify-center rounded-full outline-2'>
                            {viewProps.receiverId ? (
                                <FaCheck className='bg-status-success text-background-surface absolute top-0 right-0 size-4 rounded-full p-0.5' />
                            ) : (
                                <FaXmark className='bg-brand-muted text-background-surface absolute top-0 right-0 size-4 rounded-full p-0.5' />
                            )}
                            <ICONS.ENTITY.USER className='size-1/2' />
                        </div>
                        <div className='inline-flex flex-col items-start justify-center gap-1'>
                            <div className='text-foreground-default justify-start text-base font-semibold'>{CommonMessage.OBJECTS.TRANSACTION.RECEIVER}</div>
                        </div>
                    </div>
                </div>

                <UserSelectV2
                    key={viewProps.receiverId}
                    value={viewProps.receiverId}
                    onChange={viewProps.setReceiverId}
                    hideLabel
                    isClearable
                    showSelectedDetails
                />
            </div>

            <div
                data-state='Open'
                className='outline-border-default inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4 outline-1'>
                <div className='inline-flex items-center justify-between self-stretch'>
                    <div className='flex items-center justify-start gap-4'>
                        <div className='outline-border-default relative flex size-12 items-center justify-center rounded-full outline-2'>
                            <LuShoppingCart className='size-1/2' />
                        </div>
                        <div className='inline-flex flex-col items-start justify-center gap-1'>
                            <div className='text-foreground-default justify-start text-base font-semibold'>{CommonMessage.OBJECTS.PRODUCT.SUPPLIER}</div>
                        </div>
                    </div>
                </div>

                <TextInput
                    className='w-full'
                    value={viewProps.supplier || ''}
                    onChange={viewProps.setSupplier}
                />
            </div>
        </div>
    );
};

export default EnterReceiverSupplier;
